module.exports = __webpack_public_path__ + "static/assets/8136b7b7f123872c16729fe212e6d243.png";